import { InputFieldV5 } from "components/form";

const INPUT_FIELDS = [
  {
    name: "password",
    group: "changePassword",
    type: "password",
    icon: "fa fa-key",
    className: "input ",
    component: InputFieldV5,
    required: true,
  },
  {
    name: "newPassword",
    group: "changePassword",
    type: "password",
    icon: "fa fa-key",
    className: "input ",
    component: InputFieldV5,
    required: true,
  },
  {
    name: "newPassword2",
    group: "changePassword",
    type: "password",
    icon: "fa fa-key",
    className: "input ",
    component: InputFieldV5,
    required: true,
  },
];

export { INPUT_FIELDS };
